export default __webpack_public_path__ + "static/media/415.1e4861a4.png";